// extracted by mini-css-extract-plugin
export default {"rating":"SF-z","numberOfStars":"TF-z","count":"UF-z","barGraphSpacing":"VF-z","barGraph":"WF-z"};